import { Injectable } from '@angular/core';
import { json2csvAsync } from 'json-2-csv';
const csvtojsonV2 = require('csvtojson');

@Injectable()
export class CsvService {

  navigator: any = navigator;


  async download(data: any, filename: string) {
    const csvData = await json2csvAsync(data);

    const a: any = document.createElement('a');
    a.setAttribute('style', 'display:none;');
    document.body.appendChild(a);
    const blob = new Blob([csvData], { type: 'text/csv' });

    a.href = window.URL.createObjectURL(blob);

    const isIE = !!(document as any).documentMode;

    if (isIE) {
      this.navigator.msSaveBlob(blob, filename + '.csv');
    } else {
      a.download = filename + '.csv';
      a.click();
    }

  }

  generateJSON(csv) {
    const lines = csv.split('\n');
    const result = [];

    const headers = lines[0].split(',');

    for (let i = 1; i < lines.length; i++) {

      const obj = {};
      const currentline = lines[i].split(',');

      for (let j = 0; j < headers.length; j++) {
        obj[headers[j]] = currentline[j];
      }

      result.push(obj);

    }

    return result; // JSON
  }

  async generate(csv) {
    return await csvtojsonV2().fromString(csv);
  }

}